
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { ServiceSuggestion } from "@/types/services";

export const useServiceSuggestions = (profession: string | null) => {
  const { toast } = useToast();
  const [suggestions, setSuggestions] = useState<ServiceSuggestion[]>([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);

  useEffect(() => {
    if (profession) {
      console.log('Preparing to fetch suggestions for:', profession);
      fetchServiceSuggestions(profession);
    }
  }, [profession]);

  const fetchServiceSuggestions = async (profession: string) => {
    setLoadingSuggestions(true);
    try {
      console.log('Fetching suggestions for profession:', profession);
      
      const { data, error } = await supabase.functions.invoke('generate-service-suggestions', {
        body: { profession }
      });

      if (error) {
        console.error('Error fetching service suggestions:', error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "Failed to get service suggestions. Please try again.",
        });
        return;
      }

      if (data && data.services) {
        console.log('Received service suggestions:', data.services);
        setSuggestions(data.services);
      }
    } catch (error) {
      console.error('Error:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to get service suggestions. Please try again.",
      });
    } finally {
      setLoadingSuggestions(false);
    }
  };

  return { suggestions, loadingSuggestions };
};
